// Экранирование HTML для защиты от XSS
export function escapeHtml(text) {
  if (text == null) return '';
  const map = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;',
  };
  return String(text).replace(/[&<>"']/g, (m) => map[m]);
}

// Подсветка совпадений в тексте
export function highlightMatches(text, query) {
  if (!query || !text) return escapeHtml(text || '-');

  const escapedText = escapeHtml(text);
  const escapedQuery = escapeHtml(query);

  // Проверяем exact match (точное совпадение)
  const exactMatch = text.toLowerCase() === query.toLowerCase();
  if (exactMatch) {
    return `<span class="exact-match">${escapedText}</span>`;
  }

  // Подсвечиваем частичные совпадения
  // Экранируем специальные символы в запросе для regex
  const escapedQueryForRegex = escapedQuery.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const regex = new RegExp(
    `(${escapedQueryForRegex})`,
    'gi'
  );
  // Заменяем совпадения без добавления пробелов
  return escapedText.replace(regex, '<span class="match-highlight">$1</span>');
}

// Проверка нужно ли сворачивать строку
export function shouldCollapse(cert) {
  const subjectCn = cert.subject_cn || '';
  const issuerDn = cert.issuer_dn || '';
  const issuerOu = cert.issuer_ou || '';
  return (
    subjectCn.includes(',') ||
    issuerDn.length > 50 ||
    issuerOu.length > 30 ||
    subjectCn.length > 60
  );
}

